module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Incidente-BN.435fb387.svg";